// Translation catalogues (8 October 2026): one folder per language, and one file per part of the console in each.
// English is the complete reference; every other language falls back to English for a key it does not have (see
// I18nProvider.translate). sections.json says which keys belong in which file and how each file should sound, and
// README.md says how to add a language. French, Spanish and Portuguese have folders ready to translate; they are
// not offered until they are added here.

import afrikaans from './afrikaans/index';
import english from './english/index';
import sesotho from './sesotho/index';
import xhosa from './xhosa/index';
import zulu from './zulu/index';
import type { Catalog, Locale } from './types';

export type { Catalog, Locale } from './types';
export { LOCALES } from './types';

export const CATALOGS: Record<Locale, Catalog> = { en: english, af: afrikaans, zu: zulu, xh: xhosa, st: sesotho };
